import React from 'react';



const SortDropdown = ({ isOpenSort, trigger, menuu }) => {


    return (
        <>
            <div className='dropdown'>
                {trigger}
                {isOpenSort ? (
                    <ul className='menu'>
                        {menuu && menuu.map((menuItem, index) => {
                            return (
                                <li key={index} className='menu-item'>
                                    {menuItem}
                                </li>
                            )
                        })}
                    </ul>
                ) : null
                }
            </div>
        </>
    )
}


export default SortDropdown;